var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEWalletGray = function SvgEWalletGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87,
    height: 87,
    viewBox: "0 0 87 87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3838",
    "data-name": "Rectangle 3838",
    width: 87,
    height: 87,
    transform: "translate(0)",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4720",
    "data-name": "Group 4720",
    transform: "translate(-1977.308 -107.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M18.943,14.227H6.257A6.63,6.63,0,0,1,3.549,13.5,6.068,6.068,0,0,1,1.478,11.78,7.544,7.544,0,0,1,.095,8.427,5.979,5.979,0,0,1,.637,4.664,8.27,8.27,0,0,1,2.8,2.039,13.32,13.32,0,0,1,6.257,0H18.943V14.226Zm-11.5-11.3a4.332,4.332,0,1,0,4.332,4.331A4.336,4.336,0,0,0,7.444,2.924Zm0,5.773A1.442,1.442,0,1,1,8.886,7.255,1.444,1.444,0,0,1,7.444,8.7Z",
    transform: "translate(2036.816 143.76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M16,32A16,16,0,0,1,4.686,4.686,16,16,0,1,1,27.314,27.314,15.9,15.9,0,0,1,16,32ZM6.971,16.8v1.615h2.3A7.817,7.817,0,0,0,16.7,23.787l.213,0a8.826,8.826,0,0,0,6.173-2.733l-2-2.223a5.981,5.981,0,0,1-4,1.793h-.049a4.6,4.6,0,0,1-3.93-2.228h5.071V16.778H12.5a5.629,5.629,0,0,1-.071-.855,4.014,4.014,0,0,1,.087-.9h5.668V13.386H13.137a4.582,4.582,0,0,1,3.907-2.164h.05a5.556,5.556,0,0,1,4,1.99l1.993-2.459a8.579,8.579,0,0,0-6.033-2.535c-.092,0-.185,0-.278,0a7.971,7.971,0,0,0-7.439,5.172H6.971v1.641H8.939c-.024.329-.045.626-.045.94s.02.542.042.789l0,.042Z",
    transform: "translate(1985.308 152.308)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_97",
    "data-name": "Mask Group 97",
    transform: "translate(1977.308 107.308)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4750",
    "data-name": "Group 4750",
    transform: "translate(5.481 8.407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4749",
    "data-name": "Group 4749",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4655",
    "data-name": "Path 4655",
    d: "M20.259,31A18.259,18.259,0,1,0,38.519,49.259,18.259,18.259,0,0,0,20.259,31Zm0,34.082A15.823,15.823,0,1,1,36.082,49.259,15.823,15.823,0,0,1,20.259,65.082Z",
    transform: "translate(-2 3.69)",
    stroke: "#696d6d",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4656",
    "data-name": "Path 4656",
    d: "M72.513,12.738H61.558V4.223A1.223,1.223,0,0,0,60.335,3H14.088A6.094,6.094,0,0,0,8,9.088V35.734a1.223,1.223,0,1,0,2.446,0V13.955A6.5,6.5,0,0,0,14.1,15.178H71.29V29.784H61.558a8.521,8.521,0,1,0,0,17.043H71.29v14.6H39.612a1.223,1.223,0,0,0,0,2.446h32.9a1.223,1.223,0,0,0,1.223-1.223v-48.7A1.223,1.223,0,0,0,72.513,12.738Zm-58.429,0a3.652,3.652,0,1,1,0-7.3H59.122v7.3ZM61.558,44.386a6.087,6.087,0,1,1,0-12.172H71.29V44.386Z",
    transform: "translate(-0.087 -3)",
    stroke: "#696d6d",
    strokeWidth: 0.8
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M2045.15,127.6v-9.777h-47.238s-4.235,1.459-4.235,5.292,4.235,4.485,4.235,4.485Z",
    transform: "translate(-1.761 -1.139)"
  }))));
};
export default SvgEWalletGray;